<template>
	<div class="hello" id="box">
		<!-- 顶部 -->
		<div class="title">
			<div>
				<el-dropdown trigger="click">
					<span class="el-dropdown-link"  @mouseover="changeMask(true,'a')" @mouseout="changeMask(false,'a')" :id="'abc'+('a')">
						<img src="../assets/Frame.png" alt="">
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item >
							<li v-for="(item, index) in filterNavItem" class="filter-nav-item" :class="{ active: index == filterNavItemActive }"
								:data-target="item.target" @click="returnIdAddress('#' + item.target, index)">
								{{ item.name }}
							</li>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<img class="title_style" src="../assets/logo.png">
			</div>
		</div>
		<!-- 第一部分 -->
		<div class="part_one" id="one">
			<div class="part_one_module">
				<div class="part_one_module_title">领博生物</div>
				<div class="part_one_module_scroll">LEADBIO TECH</div>
				<div class="part_one_module_drawing">再生修复材料与再生人工器官研发平台</div>
				<div class="part_one_module_text">致力于成为全球领先的组织再生修复与再生人工器官研发与制造的平台型企业</div>
			</div>
			<div class="part_tow_module">
				<img :src="srcList" >
				<div class="part_tow_img">
					<img v-for="(item,index) in srcLista" :src="item" @click="substitute(item)" @mouseover="changeMask(true,index)" @mouseout="changeMask(false,index)" :id="'abc'+index">
				</div>
			</div>
		</div>
		<!-- 第二部分 -->
		<div style="width: 100%;" id="tow"></div>
		<div class="part_two">
			<div class="part_two_one">
				<div class="part_two_one_title">关于<span>我们</span></div>
				<div class="part_two_one_symbol">”</div>
				<div class="part_two_one_essay">按中国申报中人工血管产品统计量，领博生物科技（杭州)有限公司是中国领先的生物型人工血管医疗器械研发企业。</div>
				<div class="part_two_one_essay_one">
					公司在研的“Skeletal Acellular Vessels”骨架脱细胞人工血管（SAV）有望成为中国地区首个上市的生物型人工血管产品。作为中国生物型人工血管产品的先锋，公司拥有先发优势。同时公司特有的“聚合物脱细胞结合”技术，未来将有望应用于包括人工食道、人工角膜、人工尿道、组织修补、医学整形等领域。
				</div>
				<!-- <img class="part_two_one_essay_img" src="../assets/logo.png" alt=""> -->
				<div class="part_two_one_symbol_finally">”</div>
			</div>
			<div class="part_two_tow">
				<img src="../assets/logoone.png" alt="">
				<div>Innovation,Better Life</div>
				<div>因生命而创新</div>
			</div>
		</div>
		<!-- 第三部分 -->
		<div style="width: 100%;margin-bottom: 100px;" id="three"></div>
		<div class="part_three">
			<div><b class="striping">————</b> 我们<span>在做的</span> <b class="striping">————</b></div>
			<img src="../assets/imageone.png" alt="">
		</div>
		<div style="width: 100%;margin-bottom: 100px;" id="thraee"></div>
		<div class="part_three" v-if="produce.length !=0">
			<div><b class="striping">————</b> 我们<span>的产品</span> <b class="striping">————</b></div>
		</div>
		<div class="part_five">
			<div class="journalism">
				<div class="journalism_diva" v-for="(itema,indexa) in produce">
					<div class="journalism_diva_div">
						<img @mouseover="changeMask(true,indexa+3)" @mouseout="changeMask(false,indexa+3)" :id="'abc'+(indexa+3)" @click="checKmorea(itema.id)" :src="'http://www.leadbio.com'+ itema.image" alt="">
					</div>
					<div class="journalism_texta">{{itema.title}}</div>
				</div>
			</div>
		</div>
		<div class="learn_more" @mouseover="changeMask(true,6)" @mouseout="changeMask(false,6)" :id="'abc'+6" v-if="produce.length !=0" @click="check">查看全部</div>
		<!-- 第四部分 -->
		<div style="width: 100%;" id="four"></div>
		<div class="part_four">
			<img class="part_four_img" src="../assets/boshi.png">
			<div>新闻中心</div>
		</div>
		<!-- 第五部分 -->
		<div class="part_five">
			<div class="journalism">
				<div class="journalism_div" v-for="(item,index) in this.list">
					<div class="journalism_time">{{item.d}} {{item.m}} , {{item.y}}</div>
					<div class="journalism_text">{{item.title}}</div>
					<div class="journalism_more" @mouseover="changeMask(true,index+7)" @mouseout="changeMask(false,index+7)" :id="'abc'+(index+7)" @click="know(item.id)">了解更多</div>
				</div>
			</div>
		</div>
		<div class="learn_more" @mouseover="changeMask(true,10)" @mouseout="changeMask(false,10)" :id="'abc'+(10)" @click="checKmore" v-if="list.length !=0">查看全部</div>
		<!-- 第六部分 -->
		<div class="part_six">
			<img class="part_six_img_zuobiao" src="../assets/zuobiao.png">
			<img class="part_six_img" src="../assets/ditua.png">
			<div class="part_six_message">
				<div class="part_six_message_title">联系<span>我们</span></div>
				<div class="part_six_message_text">地址：中国杭州市钱塘区乔新路500号医药港小镇11幢4层</div>
				<div class="part_six_message_text">电话：+86 0571 88019027</div>
				<div class="part_six_message_text">传真：+86 0571 88019028</div>
				<div class="part_six_message_text">邮件：info@leadbio.com</div>
			</div>
		</div>
		<div class="bottom">备案信息：浙ICP备2021028688号-2</div>
	</div>
</template>

<script>
	export default {
		name: 'HelloWorld',
		data() {
			return {
				drawer: false,
				        direction: 'rtl',
				filterNavItem: [{
						target: "one",
						name: "顶部"
					},
					{
						target: "tow",
						name: "关于我们"
					},
					{
						target: "three",
						name: "我们在做的"
					},
					{
						target: "thraee",
						name: "我们的产品"
					},
					{
						target: "four",
						name: "新闻中心"
					},
				],
				filterNavItemActive: 0,
				list: [],
				produce: [],
				page: 1,
				limit: 3,

				srcList: "http://www.leadbio.com/assets/img/onea.png",
				srcLista: ["http://www.leadbio.com/assets/img/onec.png","http://www.leadbio.com/assets/img/onec%20(1).png","http://www.leadbio.com/assets/img/onec%20(2).png"],
				Width: document.body.clientWidth,
				number:""
			}
		},
		
		created() {
			this.product()
			this.journalism()
		},
		
		methods: {
			changeMask:function(b,index){    
			    if(b){
			       	document.getElementById("abc"+index).style.cursor="pointer"; 
			    }else{
			        document.getElementById("abc"+index).style.cursor="wait"; 
				}
			},
			substitute(item){
				this.srcList=item
			},
			returnIdAddress(id, index) {
				document.querySelector(id).scrollIntoView({
					behavior: "smooth"
				});
				this.filterNavItemActive = index;
			},
			// 我的产品查看更多
			check() {
				this.$router.push({
					path: '/products'
				})
			},
			// 我们的产品
			product() {
				this.$axios.request({
					method: "get",
					url: 'http://www.leadbio.com/api/product/index ',
				}).then((res) => {
					this.produce = res.data.data.data
					this.produce.splice(3,999)
				})
			},
			// 新闻中心
			journalism() {
				this.$axios.request({
					method: "get",
					url: 'http://www.leadbio.com/api/articles/index',
					params: {
						page: 1,
						limit: this.limit
					}
				}).then((res) => {
					this.list = res.data.data.data
				})
			},
			//查看更多
			checKmore() {
				this.$router.push({
					path: "/press"
				})
			},
			// 我们的产品
			checKmorea(id) {
				this.$router.push({
					path: "/commodity",
					query: {
						id: id
					}
				})
			},
			//页数
			paginationa(page) {
				this.page = page
				this.$axios.request({
					method: "get",
					url: 'http://www.leadbio.com/api/articles/index',
					params: {
						page: this.page,
						limit: this.limit
					}
				}).then((res) => {
					this.list = res.data.data.data
				})
			},
			//详情跳转
			know(id) {
				this.$router.push({
					path: '/details',
					query: {
						id: id
					}
				})
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	
	
	.hello {
		width: 1400px;
		
	}
	.striping{
		width:50px;
		/* color: #FF0000; */
	}
	.learn_more {
		text-align: center;
		font-size: 17px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
		line-height: 20px;
		letter-spacing: 3px;
		padding: 10px 40px;
		background: #C63530;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		width: 12%;
		margin-left: 42%;
		margin-bottom: 100px;
	}

	.part_five {
		margin-top: 70px;
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.journalism {
		width: 86%;
		display: flex;
		/* justify-content: space-between; */
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;

	}

	.journalism_div {
		width: 30%;
		margin-left: 3%;
		margin-bottom: 30px;
		position: relative;
	}

	.journalism_div img {
		width: 100%;
		/* height: 250px; */
	}
	.journalism_diva{
		width: 30%;
		margin-left: 3%;
		margin-bottom: 30px;
		position: relative;
		text-align: center;
	}
	.journalism_diva_div{
		height: 160px;
	}
	.journalism_diva img{
		width: 50%;
	}

	.journalism_time {
		border-left: 3px solid #C63530;
		padding-left: 10px;
		font-size: 16px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 16px;
		margin-bottom: 30px;

	}

	.journalism_text {
		font-size: 18px;
		font-family: FZLTZHK;
		font-weight: normal;
		color: #333333;
		line-height: 32px;
		margin-bottom: 30px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.journalism_texta {
		font-size: 18px;
		font-family: FZLTZHK;
		font-weight: normal;
		color: #333333;
		line-height: 32px;
	}

	.journalism_more {
		position: absolute;
		bottom: 0;
		font-size: 15px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #C63530;
		line-height: 27px;
	}

	.title {
		z-index: +9999999;
		position: fixed;
		top: 0;
		width: 1400px;
		height: 66px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.11999999731779099);
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
	}

	.title div {
		height: 66px;
		display: flex;
		align-items: center;
		margin-left: 68px;
	}

	.title_navigation {
		width: 48px;
		height: 48px;
	}

	.title_style {
		width: 150px;
		margin-left: 20px;
	}

	.part_one {
		width: 100%;
		display: flex;
		align-items: center;
		padding-top: 163px;
	}

	.part_one_module {
		height: 434px;
		width: 46%;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
	}

	.part_one_module_title {
		font-size: 75px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 75px;
		margin: 0 0 10px 64px;
	}

	.part_one_module_scroll {
		padding: 6px 16px 6px 64px;
		background: #C53631;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		font-size: 73px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #FFFFFF;
		line-height: 74px;
		margin-bottom: 60px;
	}

	.part_one_module_drawing {
		font-size: 32px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 38px;
		margin: 0 0 60px 64px;
	}

	.part_one_module_text {
		font-size: 16px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #333333;
		margin: 0 0 10px 64px;
	}

	.part_tow_module {
		margin-left: 28px;
		width: 50%;
		text-align: center;
	}

	.part_tow_module img {
		width: 400px;
	}

	.part_tow_img {
		width: 100%;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.part_tow_img img {
		width: 30%;
		height: 116px;
	}

	.part_two {
		width: 82%;
		margin-top: 90px;
		padding: 40px 120px;
		display: flex;
	}

	.part_two_one {
		width: 55%;
	}

	.part_two_one_title {
		font-size: 60px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 60px;
		margin-bottom: 20px;
	}

	.part_two_one_title span {
		color: #C63530;
	}

	.part_two_one_symbol {
		font-size: 60px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #C63530;
		line-height: 60px;
	}

	.part_two_one_symbol_finally {
		font-size: 60px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #C63530;
		line-height: 60px;
		margin-left: 100%;
	}

	.part_two_one_essay {
		padding: 40px;
		background: #F4F4F4;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		font-size: 30px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #333333;
	}

	.part_two_one_essay_one {
		width: 90%;
		font-size: 17px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 33px;
		margin: 30px 0;
	}

	.part_two_one_essay_img {
		width: 71%;
		height: 257px;
		margin-top: 30px;
	}

	.part_two_tow {
		margin-top: 200px;
		width: 45%;
		padding-left: 56px;
		text-align: center;
	}

	.part_two_tow img {
		width: 60%;
		/* height: 206px; */
		margin-bottom: 100px;
	}

	.part_two_tow div {
		text-align: center;
		font-size: 40px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #838383;
		line-height: 46px;
	}

	.part_three {
		margin: 30px 0;
		text-align: center;
		width: 100%;
	}

	.part_three div {
		font-size: 56px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #C63530;
		line-height: 56px;
	}

	.part_three div span {
		font-size: 56px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 56px;
	}

	.part_three img {
		width: 70%;
		height: 450px;
		margin-top: 30px;
	}

	.part_four {
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 30px;
		width: 1400px;
		height: 458px;
		/* background: url(../assets/atlas.png) no-repeat; */
		/* background-size: 100% 100%; */
	}

	.part_four_img {
		z-index: -99;
		position: absolute;
		width: 1400px;
	}

	.part_four div {
		font-size: 60px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
		line-height: 60px;
		text-shadow: 5px 5px 5px #838383;
	}

	.part_six {
		margin-top: 30px;
		display: flex;
		align-items: center;
		width: 1400px;
		height: 575px;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
	}

	.part_six_img {
		position: absolute;
		width: 1400px;
		z-index: -9999;
	}

	.part_six_img_zuobiao {
		width: 50px;
		position: absolute;
		margin-left: 1130px;
		margin-top: 46px;
	}

	.part_six_message {
		width: 54%;
		height: 404px;
		background: rgba(255, 255, 255, 0.5);
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
	}

	.part_six_message_title {
		margin: 46px 0 70px 100px;
		font-size: 56px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 56px;
	}

	.part_six_message_title span {
		color: #C63530;
	}

	.part_six_message_text {
		font-size: 22px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 22px;
		margin: 0 0 10px 100px;
	}

	.bottom {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 38px;
		background: #C63530;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
	}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue